import { usePeriodsQuery } from '@/app/services/periodApi';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { usePeriod } from '../context/PeriodContext';

export default function PeriodInitializer() {
  const { selectedPeriod, setSelectedPeriod } = usePeriod();
  const { data, isSuccess } = usePeriodsQuery();

  useEffect(() => {
    if (isSuccess && data?.content) {
      setSelectedPeriod(data.content[0]);
    }
  }, [data, isSuccess, setSelectedPeriod]);

  return <Outlet />;
}
